import type { ThemeItem } from '../../../core/domain'

export const MTG_ITEMS: ThemeItem[] = [
  { name: 'Sol Ring', imageUrl: null, fact: '{T}: Add {C}{C}.' },
  {
    name: 'Command Tower',
    imageUrl: null,
    fact: "{T}: Add one mana of any color in your commander's color identity."
  },
  {
    name: 'Arcane Signet',
    imageUrl: null,
    fact: "{T}: Add one mana of any color in your commander's color identity."
  },
  {
    name: 'Exotic Orchard',
    imageUrl: null,
    fact: '{T}: Add one mana of any color that a land an opponent controls could produce.'
  },
  { name: 'Reliquary Tower', imageUrl: null, fact: 'You have no maximum hand size. {T}: Add {C}.' },
  {
    name: 'Swords to Plowshares',
    imageUrl: null,
    fact: 'Exile target creature. Its controller gains life equal to its power.'
  },
  { name: 'Swiftfoot Boots', imageUrl: null, fact: 'Equipped creature has hexproof and haste.' },
  { name: 'Lightning Greaves', imageUrl: null, fact: 'Equipped creature has haste and shroud.' },
  {
    name: 'Path of Ancestry',
    imageUrl: null,
    fact: "This land enters tapped. {T}: Add one mana of any color in your commander's color identity."
  },
  {
    name: 'Path to Exile',
    imageUrl: null,
    fact: 'Exile target creature. Its controller may search their library for a basic land card, put that card onto the battlefield tapped, then shuffle.'
  },
  { name: 'Counterspell', imageUrl: null, fact: 'Counter target spell.' },
  {
    name: 'Fellwar Stone',
    imageUrl: null,
    fact: '{T}: Add one mana of any color that a land an opponent controls could produce.'
  },
  {
    name: 'Evolving Wilds',
    imageUrl: null,
    fact: '{T}, Sacrifice this land: Search your library for a basic land card, put it onto the battlefield tapped, then shuffle.'
  },
  {
    name: "Rogue's Passage",
    imageUrl: null,
    fact: "{T}: Add {C}. {4}, {T}: Target creature can't be blocked this turn."
  },
  {
    name: 'Cultivate',
    imageUrl: null,
    fact: 'Search your library for up to two basic land cards, reveal those cards, put one onto the battlefield tapped and the other into your hand, then shuffle.'
  },
  { name: 'Thought Vessel', imageUrl: null, fact: 'You have no maximum hand size. {T}: Add {C}.' },
  {
    name: 'Blasphemous Act',
    imageUrl: null,
    fact: 'This spell costs {1} less to cast for each creature on the battlefield.'
  },
  {
    name: 'Farseek',
    imageUrl: null,
    fact: 'Search your library for a Plains, Island, Swamp, or Mountain card, put it onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Beast Within',
    imageUrl: null,
    fact: 'Destroy target permanent. Its controller creates a 3/3 green Beast creature token.'
  },
  {
    name: 'Bojuka Bog',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, exile target player's graveyard."
  },
  {
    name: 'Rampant Growth',
    imageUrl: null,
    fact: 'Search your library for a basic land card, put that card onto the battlefield tapped, then shuffle.'
  },
  { name: 'Myriad Landscape', imageUrl: null, fact: 'This land enters tapped. {T}: Add {C}.' },
  {
    name: 'Terramorphic Expanse',
    imageUrl: null,
    fact: '{T}, Sacrifice this land: Search your library for a basic land card, put it onto the battlefield tapped, then shuffle.'
  },
  {
    name: "Nature's Lore",
    imageUrl: null,
    fact: 'Search your library for a Forest card, put that card onto the battlefield, then shuffle.'
  },
  {
    name: 'Chaos Warp',
    imageUrl: null,
    fact: 'The owner of target permanent shuffles it into their library, then reveals the top card of their library.'
  },
  {
    name: 'Heroic Intervention',
    imageUrl: null,
    fact: 'Permanents you control gain hexproof and indestructible until end of turn.'
  },
  {
    name: 'Mind Stone',
    imageUrl: null,
    fact: '{T}: Add {C}. {1}, {T}, Sacrifice this artifact: Draw a card.'
  },
  { name: 'Birds of Paradise', imageUrl: null, fact: 'Flying {T}: Add one mana of any color.' },
  { name: 'Dark Ritual', imageUrl: null, fact: 'Add {B}{B}{B}.' },
  { name: "An Offer You Can't Refuse", imageUrl: null, fact: 'Counter target noncreature spell.' },
  {
    name: 'Polluted Delta',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for an Island or Swamp card, put it onto the battlefield, then shuffle.'
  },
  {
    name: "Kodama's Reach",
    imageUrl: null,
    fact: 'Search your library for up to two basic land cards, reveal those cards, put one onto the battlefield tapped and the other into your hand, then shuffle.'
  },
  {
    name: 'Solemn Simulacrum',
    imageUrl: null,
    fact: 'When this creature enters, you may search your library for a basic land card, put that card onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Flooded Strand',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Plains or Island card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Misty Rainforest',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Forest or Island card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Skullclamp',
    imageUrl: null,
    fact: 'Equipped creature gets +1/-1. Whenever equipped creature dies, draw two cards.'
  },
  {
    name: 'Rhystic Study',
    imageUrl: null,
    fact: 'Whenever an opponent casts a spell, you may draw a card unless that player pays {1}.'
  },
  {
    name: 'Bloodstained Mire',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Swamp or Mountain card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Three Visits',
    imageUrl: null,
    fact: 'Search your library for a Forest card, put it onto the battlefield, then shuffle.'
  },
  {
    name: "Commander's Sphere",
    imageUrl: null,
    fact: "{T}: Add one mana of any color in your commander's color identity."
  },
  {
    name: 'Windswept Heath',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Forest or Plains card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Verdant Catacombs',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Swamp or Forest card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Wooded Foothills',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Mountain or Forest card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Scalding Tarn',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for an Island or Mountain card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Marsh Flats',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Plains or Swamp card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Cyclonic Rift',
    imageUrl: null,
    fact: "Return target nonland permanent you don't control to its owner's hand."
  },
  {
    name: 'Watery Grave',
    imageUrl: null,
    fact: '({T}: Add {U} or {B}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Fabled Passage',
    imageUrl: null,
    fact: '{T}, Sacrifice this land: Search your library for a basic land card, put it onto the battlefield tapped, then shuffle.'
  },
  { name: 'Negate', imageUrl: null, fact: 'Counter target noncreature spell.' },
  {
    name: 'Arid Mesa',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a Mountain or Plains card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Arcane Denial',
    imageUrl: null,
    fact: "Counter target spell. Its controller may draw up to two cards at the beginning of the next turn's upkeep."
  },
  {
    name: 'Reanimate',
    imageUrl: null,
    fact: 'Put target creature card from a graveyard onto the battlefield under your control.'
  },
  {
    name: 'Generous Gift',
    imageUrl: null,
    fact: 'Destroy target permanent. Its controller creates a 3/3 green Elephant creature token.'
  },
  {
    name: 'Demonic Tutor',
    imageUrl: null,
    fact: 'Search your library for a card, put that card into your hand, then shuffle.'
  },
  { name: 'Llanowar Elves', imageUrl: null, fact: '{T}: Add {G}.' },
  {
    name: 'Godless Shrine',
    imageUrl: null,
    fact: '({T}: Add {W} or {B}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Smothering Tithe',
    imageUrl: null,
    fact: 'Whenever an opponent draws a card, that player may pay {2}.'
  },
  {
    name: 'Breeding Pool',
    imageUrl: null,
    fact: '({T}: Add {G} or {U}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Ancient Tomb',
    imageUrl: null,
    fact: '{T}: Add {C}{C}. This land deals 2 damage to you.'
  },
  {
    name: 'Hallowed Fountain',
    imageUrl: null,
    fact: '({T}: Add {W} or {U}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Toxic Deluge',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, pay X life.'
  },
  {
    name: 'Steam Vents',
    imageUrl: null,
    fact: '({T}: Add {U} or {R}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Stomping Ground',
    imageUrl: null,
    fact: '({T}: Add {R} or {G}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Blood Crypt',
    imageUrl: null,
    fact: '({T}: Add {B} or {R}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Overgrown Tomb',
    imageUrl: null,
    fact: '({T}: Add {B} or {G}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Brainstorm',
    imageUrl: null,
    fact: 'Draw three cards, then put two cards from your hand on top of your library in any order.'
  },
  {
    name: 'Urborg, Tomb of Yawgmoth',
    imageUrl: null,
    fact: 'Each land is a Swamp in addition to its other land types.'
  },
  {
    name: 'Swan Song',
    imageUrl: null,
    fact: 'Counter target enchantment, instant, or sorcery spell.'
  },
  {
    name: 'Temple of the False God',
    imageUrl: null,
    fact: '{T}: Add {C}{C}. Activate only if you control five or more lands.'
  },
  {
    name: 'Yavimaya, Cradle of Growth',
    imageUrl: null,
    fact: 'Each land is a Forest in addition to its other land types.'
  },
  {
    name: 'Esper Sentinel',
    imageUrl: null,
    fact: "Whenever an opponent casts their first noncreature spell each turn, draw a card unless that player pays {X}, where X is this creature's power."
  },
  {
    name: 'Sacred Foundry',
    imageUrl: null,
    fact: '({T}: Add {R} or {W}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Boseiju, Who Endures',
    imageUrl: null,
    fact: '{T}: Add {G}. Channel — {1}{G}, Discard this card: Destroy target artifact, enchantment, or nonbasic land an opponent controls.'
  },
  {
    name: 'Deflecting Swat',
    imageUrl: null,
    fact: 'If you control a commander, you may cast this spell without paying its mana cost.'
  },
  {
    name: 'Fierce Guardianship',
    imageUrl: null,
    fact: 'If you control a commander, you may cast this spell without paying its mana cost.'
  },
  {
    name: 'Chromatic Lantern',
    imageUrl: null,
    fact: 'Lands you control have "{T}: Add one mana of any color." {T}: Add one mana of any color.'
  },
  {
    name: 'Temple Garden',
    imageUrl: null,
    fact: '({T}: Add {G} or {W}.) As this land enters, you may pay 2 life.'
  },
  {
    name: 'Sulfur Falls',
    imageUrl: null,
    fact: 'This land enters tapped unless you control an Island or a Mountain.'
  },
  {
    name: 'Clifftop Retreat',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Mountain or a Plains.'
  },
  {
    name: 'Cinder Glade',
    imageUrl: null,
    fact: '({T}: Add {R} or {G}.) This land enters tapped unless you control two or more basic lands.'
  },
  {
    name: 'Sunken Hollow',
    imageUrl: null,
    fact: '({T}: Add {U} or {B}.) This land enters tapped unless you control two or more basic lands.'
  },
  {
    name: 'Dragonskull Summit',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Swamp or a Mountain.'
  },
  {
    name: 'Feed the Swarm',
    imageUrl: null,
    fact: 'Destroy target creature or enchantment an opponent controls.'
  },
  {
    name: 'The One Ring',
    imageUrl: null,
    fact: 'Indestructible When The One Ring enters, if you cast it, you gain protection from everything until your next turn.'
  },
  {
    name: 'Otawara, Soaring City',
    imageUrl: null,
    fact: "{T}: Add {U}. Channel — {3}{U}, Discard this card: Return target artifact, creature, enchantment, or planeswalker to its owner's hand."
  },
  { name: 'Talisman of Dominance', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {U} or {B}.' },
  {
    name: "Garruk's Uprising",
    imageUrl: null,
    fact: 'When this enchantment enters, if you control a creature with power 4 or greater, draw a card.'
  },
  {
    name: 'Isolated Chapel',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Plains or a Swamp.'
  },
  { name: 'Faithless Looting', imageUrl: null, fact: 'Draw two cards, then discard two cards.' },
  {
    name: 'Smoldering Marsh',
    imageUrl: null,
    fact: '({T}: Add {B} or {R}.) This land enters tapped unless you control two or more basic lands.'
  },
  {
    name: 'Mystic Remora',
    imageUrl: null,
    fact: 'Cumulative upkeep {1} (At the beginning of your upkeep, put an age counter on this permanent, then sacrifice it unless you pay its upkeep cost for each age counter on it.) Whenever an opponent casts a noncreature spel...'
  },
  {
    name: 'Phyrexian Arena',
    imageUrl: null,
    fact: 'At the beginning of your upkeep, you draw a card and you lose 1 life.'
  },
  {
    name: 'City of Brass',
    imageUrl: null,
    fact: 'Whenever this land becomes tapped, it deals 1 damage to you.'
  },
  {
    name: 'Glacial Fortress',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Plains or an Island.'
  },
  {
    name: 'Hinterland Harbor',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Forest or an Island.'
  },
  { name: 'Vandalblast', imageUrl: null, fact: "Destroy target artifact you don't control." },
  {
    name: "Jeska's Will",
    imageUrl: null,
    fact: 'Choose one. If you control a commander as you cast this spell, you may choose both instead.'
  },
  {
    name: 'Canopy Vista',
    imageUrl: null,
    fact: '({T}: Add {G} or {W}.) This land enters tapped unless you control two or more basic lands.'
  },
  {
    name: "Teferi's Protection",
    imageUrl: null,
    fact: "Until your next turn, your life total can't change and you gain protection from everything."
  },
  { name: 'Frantic Search', imageUrl: null, fact: 'Draw two cards, then discard two cards.' },
  {
    name: 'Prairie Stream',
    imageUrl: null,
    fact: '({T}: Add {W} or {U}.) This land enters tapped unless you control two or more basic lands.'
  },
  {
    name: 'Sakura-Tribe Elder',
    imageUrl: null,
    fact: 'Sacrifice this creature: Search your library for a basic land card, put that card onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Eternal Witness',
    imageUrl: null,
    fact: 'When this creature enters, you may return target card from your graveyard to your hand.'
  },
  { name: 'Elvish Mystic', imageUrl: null, fact: '{T}: Add {G}.' },
  {
    name: 'Vampiric Tutor',
    imageUrl: null,
    fact: 'Search your library for a card, then shuffle and put that card on top.'
  },
  {
    name: 'Drowned Catacomb',
    imageUrl: null,
    fact: 'This land enters tapped unless you control an Island or a Swamp.'
  },
  {
    name: 'Deadly Rollick',
    imageUrl: null,
    fact: 'If you control a commander, you may cast this spell without paying its mana cost.'
  },
  { name: 'Cavern of Souls', imageUrl: null, fact: 'As this land enters, choose a creature type.' },
  {
    name: 'Woodland Cemetery',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Swamp or a Forest.'
  },
  {
    name: 'Mana Drain',
    imageUrl: null,
    fact: "Counter target spell. At the beginning of your next main phase, add an amount of {C} equal to that spell's mana value."
  },
  { name: 'Shivan Reef', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {U} or {R}.' },
  {
    name: "Wayfarer's Bauble",
    imageUrl: null,
    fact: '{2}, {T}, Sacrifice this artifact: Search your library for a basic land card, put that card onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Lotus Petal',
    imageUrl: null,
    fact: '{T}, Sacrifice this artifact: Add one mana of any color.'
  },
  {
    name: 'Propaganda',
    imageUrl: null,
    fact: "Creatures can't attack you unless their controller pays {2} for each creature they control that's attacking you."
  },
  { name: 'Mana Confluence', imageUrl: null, fact: '{T}, Pay 1 life: Add one mana of any color.' },
  {
    name: "Urza's Saga",
    imageUrl: null,
    fact: '(As this Saga enters and after your draw step, add a lore counter.'
  },
  {
    name: 'Enlightened Tutor',
    imageUrl: null,
    fact: 'Search your library for an artifact or enchantment card, reveal it, then shuffle and put that card on top.'
  },
  { name: 'Battlefield Forge', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {R} or {W}.' },
  {
    name: "Assassin's Trophy",
    imageUrl: null,
    fact: 'Destroy target permanent an opponent controls.'
  },
  { name: 'Caves of Koilos', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {W} or {B}.' },
  { name: 'Talisman of Creativity', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {U} or {R}.' },
  {
    name: 'Victimize',
    imageUrl: null,
    fact: 'Choose two target creature cards in your graveyard.'
  },
  {
    name: 'Deadly Dispute',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice an artifact or creature.'
  },
  {
    name: 'Rootbound Crag',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Mountain or a Forest.'
  },
  { name: 'Talisman of Indulgence', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {R}.' },
  { name: "Ashnod's Altar", imageUrl: null, fact: 'Sacrifice a creature: Add {C}{C}.' },
  {
    name: 'Black Market Connections',
    imageUrl: null,
    fact: 'At the beginning of your first main phase, choose one or more — • Sell Contraband — Create a Treasure token.'
  },
  {
    name: 'Roaming Throne',
    imageUrl: null,
    fact: 'Ward {2} As this creature enters, choose a creature type.'
  },
  { name: 'Yavimaya Coast', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {G} or {U}.' },
  {
    name: 'Sunpetal Grove',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Forest or a Plains.'
  },
  { name: 'Talisman of Hierarchy', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {W} or {B}.' },
  { name: 'Llanowar Wastes', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {G}.' },
  {
    name: 'Blood Artist',
    imageUrl: null,
    fact: 'Whenever this creature or another creature dies, target player loses 1 life and you gain 1 life.'
  },
  {
    name: 'Morphic Pool',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  { name: 'Dimir Signet', imageUrl: null, fact: '{1}, {T}: Add {U}{B}.' },
  {
    name: "Herald's Horn",
    imageUrl: null,
    fact: 'As this artifact enters, choose a creature type.'
  },
  {
    name: 'Chrome Mox',
    imageUrl: null,
    fact: 'Imprint — When this artifact enters, you may exile a nonartifact, nonland card from your hand.'
  },
  {
    name: 'Ponder',
    imageUrl: null,
    fact: 'Look at the top three cards of your library, then put them back in any order.'
  },
  {
    name: 'Mana Vault',
    imageUrl: null,
    fact: "This artifact doesn't untap during your untap step."
  },
  {
    name: 'Rejuvenating Springs',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Mystical Tutor',
    imageUrl: null,
    fact: 'Search your library for an instant or sorcery card, reveal it, then shuffle and put that card on top.'
  },
  {
    name: 'War Room',
    imageUrl: null,
    fact: "{T}: Add {C}. {3}, {T}, Pay life equal to the number of colors in your commanders' color identity: Draw a card."
  },
  { name: 'Talisman of Progress', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {W} or {U}.' },
  {
    name: 'Abrade',
    imageUrl: null,
    fact: 'Choose one — • Abrade deals 3 damage to target creature.'
  },
  {
    name: 'Training Center',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Windfall',
    imageUrl: null,
    fact: 'Each player discards their hand, then draws cards equal to the greatest number of cards a player discarded this way.'
  },
  { name: 'Underground River', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {U} or {B}.' },
  { name: 'Anguished Unmaking', imageUrl: null, fact: 'Exile target nonland permanent.' },
  { name: 'Talisman of Conviction', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {R} or {W}.' },
  { name: 'Pongify', imageUrl: null, fact: "Destroy target creature. It can't be regenerated." },
  { name: 'Sulfurous Springs', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {R}.' },
  { name: 'Lightning Bolt', imageUrl: null, fact: 'Lightning Bolt deals 3 damage to any target.' },
  {
    name: 'Delighted Halfling',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}: Add one mana of any color.'
  },
  { name: 'Adarkar Wastes', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {W} or {U}.' },
  {
    name: 'Big Score',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, discard a card.'
  },
  { name: 'Farewell', imageUrl: null, fact: 'Choose one or more — • Exile all artifacts.' },
  { name: 'Rakdos Signet', imageUrl: null, fact: '{1}, {T}: Add {B}{R}.' },
  {
    name: 'Ghostly Prison',
    imageUrl: null,
    fact: "Creatures can't attack you unless their controller pays {2} for each creature they control that's attacking you."
  },
  {
    name: 'Luxury Suite',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Worldly Tutor',
    imageUrl: null,
    fact: 'Search your library for a creature card, reveal it, then shuffle and put the card on top.'
  },
  {
    name: 'Sea of Clouds',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  { name: 'Izzet Signet', imageUrl: null, fact: '{1}, {T}: Add {U}{R}.' },
  { name: 'Austere Command', imageUrl: null, fact: 'Choose two — • Destroy all artifacts.' },
  {
    name: 'Vault of Champions',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Nykthos, Shrine to Nyx',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}, {T}: Choose a color.'
  },
  {
    name: 'Spectator Seating',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Mystic Sanctuary',
    imageUrl: null,
    fact: '({T}: Add {U}.) This land enters tapped unless you control three or more other Islands.'
  },
  {
    name: 'Reflecting Pool',
    imageUrl: null,
    fact: '{T}: Add one mana of any type that a land you control could produce.'
  },
  {
    name: 'Undergrowth Stadium',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Return of the Wildspeaker',
    imageUrl: null,
    fact: 'Choose one — • Draw cards equal to the greatest power among non-Human creatures you control.'
  },
  {
    name: 'Boros Charm',
    imageUrl: null,
    fact: 'Choose one — • Boros Charm deals 4 damage to target player or planeswalker.'
  },
  { name: 'Orzhov Signet', imageUrl: null, fact: '{1}, {T}: Add {W}{B}.' },
  {
    name: 'Gemstone Caverns',
    imageUrl: null,
    fact: "If this card is in your opening hand and you're not the starting player, you may begin the game with Gemstone Caverns on the battlefield with a luck counter on it."
  },
  {
    name: 'Tireless Provisioner',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, create a Food token or a Treasure token.'
  },
  {
    name: 'Dreamroot Cascade',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Three Tree City',
    imageUrl: null,
    fact: 'As Three Tree City enters, choose a creature type.'
  },
  {
    name: 'Command Beacon',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}, Sacrifice this land: Put your commander into your hand from the command zone.'
  },
  {
    name: 'Flawless Maneuver',
    imageUrl: null,
    fact: 'If you control a commander, you may cast this spell without paying its mana cost.'
  },
  { name: "Night's Whisper", imageUrl: null, fact: 'You draw two cards and lose 2 life.' },
  {
    name: 'Impact Tremors',
    imageUrl: null,
    fact: 'Whenever a creature you control enters, this enchantment deals 1 damage to each opponent.'
  },
  {
    name: 'Spire Garden',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Hardened Scales',
    imageUrl: null,
    fact: 'If one or more +1/+1 counters would be put on a creature you control, that many plus one +1/+1 counters are put on it instead.'
  },
  { name: 'Cabal Coffers', imageUrl: null, fact: '{2}, {T}: Add {B} for each Swamp you control.' },
  {
    name: 'Force of Will',
    imageUrl: null,
    fact: "You may pay 1 life and exile a blue card from your hand rather than pay this spell's mana cost."
  },
  {
    name: 'Mosswort Bridge',
    imageUrl: null,
    fact: 'Hideaway 4 (When this land enters, look at the top four cards of your library, exile one face down, then put the rest on the bottom in a random order.) This land enters tapped.'
  },
  {
    name: 'Ash Barrens',
    imageUrl: null,
    fact: '{T}: Add {C}. Basic landcycling {1} ({1}, Discard this card: Search your library for a basic land card, reveal it, put it into your hand, then shuffle.)'
  },
  {
    name: 'Village Rites',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice a creature.'
  },
  { name: 'Stroke of Midnight', imageUrl: null, fact: 'Destroy target nonland permanent.' },
  {
    name: "Akroma's Will",
    imageUrl: null,
    fact: 'Choose one. If you control a commander as you cast this spell, you may choose both instead.'
  },
  {
    name: 'Prismatic Vista',
    imageUrl: null,
    fact: '{T}, Pay 1 life, Sacrifice this land: Search your library for a basic land card, put it onto the battlefield, then shuffle.'
  },
  {
    name: 'Idol of Oblivion',
    imageUrl: null,
    fact: '{T}: Draw a card. Activate only if you created a token this turn.'
  },
  {
    name: 'Doubling Season',
    imageUrl: null,
    fact: 'If an effect would create one or more tokens under your control, it creates twice that many of those tokens instead.'
  },
  {
    name: 'Buried Ruin',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}, {T}, Sacrifice this land: Return target artifact card from your graveyard to your hand.'
  },
  {
    name: 'Phyrexian Tower',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}, Sacrifice a creature: Add {B}{B}.'
  },
  {
    name: 'Stormcarved Coast',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  { name: "Karn's Bastion", imageUrl: null, fact: '{T}: Add {C}. {4}, {T}: Proliferate.' },
  {
    name: 'Thrill of Possibility',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, discard a card.'
  },
  { name: 'Azorius Signet', imageUrl: null, fact: '{1}, {T}: Add {W}{U}.' },
  {
    name: 'Rhythm of the Wild',
    imageUrl: null,
    fact: "Creature spells you control can't be countered."
  },
  { name: 'Thran Dynamo', imageUrl: null, fact: '{T}: Add {C}{C}{C}.' },
  {
    name: 'Mox Amber',
    imageUrl: null,
    fact: '{T}: Add one mana of any color among legendary creatures and planeswalkers you control.'
  },
  {
    name: 'Rapid Hybridization',
    imageUrl: null,
    fact: "Destroy target creature. It can't be regenerated."
  },
  {
    name: 'Storm-Kiln Artist',
    imageUrl: null,
    fact: 'This creature gets +1/+0 for each artifact you control.'
  },
  {
    name: 'Wild Growth',
    imageUrl: null,
    fact: 'Enchant land Whenever enchanted land is tapped for mana, its controller adds an additional {G}.'
  },
  {
    name: 'Beast Whisperer',
    imageUrl: null,
    fact: 'Whenever you cast a creature spell, draw a card.'
  },
  { name: 'Opt', imageUrl: null, fact: 'Scry 1. (Look at the top card of your library.' },
  {
    name: 'Bountiful Promenade',
    imageUrl: null,
    fact: 'This land enters tapped unless you have two or more opponents.'
  },
  {
    name: 'Crop Rotation',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice a land.'
  },
  {
    name: 'Professional Face-Breaker',
    imageUrl: null,
    fact: 'Menace Whenever one or more creatures you control deal combat damage to a player, create a Treasure token.'
  },
  {
    name: 'Rockfall Vale',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  { name: 'Fyndhorn Elves', imageUrl: null, fact: '{T}: Add {G}.' },
  {
    name: 'Preordain',
    imageUrl: null,
    fact: 'Scry 2, then draw a card. (To scry 2, look at the top two cards of your library, then put any number of them on the bottom and the rest on top in any order.)'
  },
  { name: 'Karplusan Forest', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {R} or {G}.' },
  {
    name: 'Scute Swarm',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, create a 1/1 green Insect creature token.'
  },
  {
    name: 'Mirkwood Bats',
    imageUrl: null,
    fact: 'Flying Whenever you create or sacrifice a token, each opponent loses 1 life.'
  },
  {
    name: 'Ornithopter of Paradise',
    imageUrl: null,
    fact: 'Flying {T}: Add one mana of any color.'
  },
  {
    name: 'Animate Dead',
    imageUrl: null,
    fact: 'Enchant creature card in a graveyard When this Aura enters, if it\'s on the battlefield, it loses "enchant creature card in a graveyard" and gains "enchant creature put onto the battlefield with this Aura." Return ...'
  },
  {
    name: 'Secluded Courtyard',
    imageUrl: null,
    fact: 'As this land enters, choose a creature type.'
  },
  {
    name: "Sensei's Divining Top",
    imageUrl: null,
    fact: '{1}: Look at the top three cards of your library, then put them back in any order.'
  },
  {
    name: 'Growth Spiral',
    imageUrl: null,
    fact: 'Draw a card. You may put a land card from your hand onto the battlefield.'
  },
  { name: 'Terminate', imageUrl: null, fact: "Destroy target creature. It can't be regenerated." },
  {
    name: 'Pitiless Plunderer',
    imageUrl: null,
    fact: 'Whenever another creature you control dies, create a Treasure token.'
  },
  {
    name: 'Patchwork Banner',
    imageUrl: null,
    fact: 'As this artifact enters, choose a creature type.'
  },
  {
    name: 'Sign in Blood',
    imageUrl: null,
    fact: 'Target player draws two cards and loses 2 life.'
  },
  {
    name: 'Shipwreck Marsh',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Zulaport Cutthroat',
    imageUrl: null,
    fact: 'Whenever this creature or another creature you control dies, each opponent loses 1 life and you gain 1 life.'
  },
  { name: 'Explore', imageUrl: null, fact: 'You may play an additional land this turn.' },
  {
    name: 'Gamble',
    imageUrl: null,
    fact: 'Search your library for a card, put that card into your hand, discard a card at random, then shuffle.'
  },
  {
    name: 'The Great Henge',
    imageUrl: null,
    fact: 'This spell costs {X} less to cast, where X is the greatest power among creatures you control.'
  },
  { name: 'Boros Signet', imageUrl: null, fact: '{1}, {T}: Add {R}{W}.' },
  { name: 'Mox Opal', imageUrl: null, fact: 'Metalcraft — {T}: Add one mana of any color.' },
  { name: 'Brushland', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {G} or {W}.' },
  {
    name: 'Harrow',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice a land.'
  },
  {
    name: 'Gray Merchant of Asphodel',
    imageUrl: null,
    fact: 'When this creature enters, each opponent loses X life, where X is your devotion to black.'
  },
  {
    name: 'Mithril Coat',
    imageUrl: null,
    fact: 'Flash Indestructible When Mithril Coat enters, attach it to target legendary creature you control.'
  },
  {
    name: 'Takenuma, Abandoned Mire',
    imageUrl: null,
    fact: '{T}: Add {B}. Channel — {3}{B}, Discard this card: Mill three cards, then return a creature or planeswalker card from your graveyard to your hand.'
  },
  {
    name: 'Sword of the Animist',
    imageUrl: null,
    fact: 'Equipped creature gets +1/+1. Whenever equipped creature attacks, you may search your library for a basic land card, put it onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Unclaimed Territory',
    imageUrl: null,
    fact: 'As this land enters, choose a creature type.'
  },
  {
    name: "Rishkar's Expertise",
    imageUrl: null,
    fact: 'Draw cards equal to the greatest power among creatures you control.'
  },
  {
    name: 'Mox Diamond',
    imageUrl: null,
    fact: 'If this artifact would enter, you may discard a land card instead.'
  },
  {
    name: 'Grand Abolisher',
    imageUrl: null,
    fact: "During your turn, your opponents can't cast spells or activate abilities of artifacts, creatures, or enchantments."
  },
  {
    name: "Dovin's Veto",
    imageUrl: null,
    fact: "This spell can't be countered. Counter target noncreature spell."
  },
  {
    name: 'Everflowing Chalice',
    imageUrl: null,
    fact: 'Multikicker {2} (You may pay an additional {2} any number of times as you cast this spell.) This artifact enters with a charge counter on it for each time it was kicked.'
  },
  {
    name: 'Syr Konrad, the Grim',
    imageUrl: null,
    fact: 'Whenever another creature dies, or a creature card is put into a graveyard from anywhere other than the battlefield, or a creature card leaves your graveyard, Syr Konrad deals 1 damage to each opponent.'
  },
  {
    name: 'Viscera Seer',
    imageUrl: null,
    fact: 'Sacrifice a creature: Scry 1. (Look at the top card of your library.'
  },
  {
    name: 'Orcish Bowmasters',
    imageUrl: null,
    fact: 'Flash When this creature enters and whenever an opponent draws a card except the first one they draw in each of their draw steps, this creature deals 1 damage to any target.'
  },
  {
    name: 'Foundry Inspector',
    imageUrl: null,
    fact: 'Artifact spells you cast cost {1} less to cast.'
  },
  {
    name: 'Sylvan Library',
    imageUrl: null,
    fact: 'At the beginning of your draw step, you may draw two additional cards.'
  },
  {
    name: 'Morbid Opportunist',
    imageUrl: null,
    fact: 'Whenever one or more other creatures die, draw a card.'
  },
  {
    name: 'Archmage Emeritus',
    imageUrl: null,
    fact: 'Magecraft — Whenever you cast or copy an instant or sorcery spell, draw a card.'
  },
  {
    name: 'Basilisk Collar',
    imageUrl: null,
    fact: 'Equipped creature has deathtouch and lifelink.'
  },
  {
    name: 'Etali, Primal Storm',
    imageUrl: null,
    fact: "Whenever Etali attacks, exile the top card of each player's library, then you may cast any number of spells from among those cards without paying their mana costs."
  },
  {
    name: 'Panharmonicon',
    imageUrl: null,
    fact: 'If an artifact or creature entering causes a triggered ability of a permanent you control to trigger, that ability triggers an additional time.'
  },
  {
    name: "Bolas's Citadel",
    imageUrl: null,
    fact: 'You may look at the top card of your library any time.'
  },
  {
    name: 'Academy Manufactor',
    imageUrl: null,
    fact: 'If you would create a Clue, Food, or Treasure token, instead create one of each.'
  },
  { name: 'Infernal Grasp', imageUrl: null, fact: 'Destroy target creature. You lose 2 life.' },
  {
    name: 'Diabolic Intent',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice a creature.'
  },
  {
    name: 'Force of Negation',
    imageUrl: null,
    fact: "If it's not your turn, you may exile a blue card from your hand rather than pay this spell's mana cost."
  },
  { name: 'Hullbreaker Horror', imageUrl: null, fact: "Flash This spell can't be countered." },
  {
    name: 'Ragavan, Nimble Pilferer',
    imageUrl: null,
    fact: "Whenever Ragavan deals combat damage to a player, create a Treasure token and exile the top card of that player's library."
  },
  { name: 'Snap', imageUrl: null, fact: "Return target creature to its owner's hand." },
  {
    name: 'Temple of Epiphany',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Inspiring Call',
    imageUrl: null,
    fact: 'Draw a card for each creature you control with a +1/+1 counter on it.'
  },
  {
    name: 'Bloom Tender',
    imageUrl: null,
    fact: 'Vivid — {T}: For each color among permanents you control, add one mana of that color.'
  },
  {
    name: 'Avenger of Zendikar',
    imageUrl: null,
    fact: 'When this creature enters, create a 0/1 green Plant creature token for each land you control.'
  },
  {
    name: 'Reality Shift',
    imageUrl: null,
    fact: 'Exile target creature. Its controller manifests the top card of their library.'
  },
  {
    name: 'Haunted Ridge',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Deserted Beach',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  { name: 'Jet Medallion', imageUrl: null, fact: 'Black spells you cast cost {1} less to cast.' },
  {
    name: 'Temple of Silence',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Seedborn Muse',
    imageUrl: null,
    fact: "Untap all permanents you control during each other player's untap step."
  },
  {
    name: "Inventors' Fair",
    imageUrl: null,
    fact: 'At the beginning of your upkeep, if you control three or more artifacts, you gain 1 life.'
  },
  {
    name: 'Exsanguinate',
    imageUrl: null,
    fact: 'Each opponent loses X life. You gain life equal to the life lost this way.'
  },
  {
    name: 'Simic Growth Chamber',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Unexpected Windfall',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, discard a card.'
  },
  { name: 'Darksteel Citadel', imageUrl: null, fact: 'Indestructible {T}: Add {C}.' },
  {
    name: 'Sun Titan',
    imageUrl: null,
    fact: 'Vigilance Whenever this creature enters or attacks, you may return target permanent card with mana value 3 or less from your graveyard to the battlefield.'
  },
  {
    name: 'Sundown Pass',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Braids, Arisen Nightmare',
    imageUrl: null,
    fact: 'At the beginning of your end step, you may sacrifice an artifact, creature, enchantment, land, or planeswalker.'
  },
  {
    name: 'Choked Estuary',
    imageUrl: null,
    fact: 'As this land enters, you may reveal an Island or Swamp card from your hand.'
  },
  {
    name: 'Dryad of the Ilysian Grove',
    imageUrl: null,
    fact: 'You may play an additional land on each of your turns.'
  },
  {
    name: 'Shattered Sanctum',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Overgrown Farmland',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Temple of Triumph',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Exploration',
    imageUrl: null,
    fact: 'You may play an additional land on each of your turns.'
  },
  {
    name: 'Skyshroud Claim',
    imageUrl: null,
    fact: 'Search your library for up to two Forest cards, put them onto the battlefield, then shuffle.'
  },
  {
    name: 'Rugged Prairie',
    imageUrl: null,
    fact: '{T}: Add {C}. {R/W}, {T}: Add {R}{R}, {R}{W}, or {W}{W}.'
  },
  {
    name: 'Decanter of Endless Water',
    imageUrl: null,
    fact: 'You have no maximum hand size. {T}: Add one mana of any color.'
  },
  { name: 'Untimely Malfunction', imageUrl: null, fact: 'Choose one — • Destroy target artifact.' },
  { name: 'Withering Torment', imageUrl: null, fact: 'Destroy target creature or enchantment.' },
  { name: 'Underground Sea', imageUrl: null, fact: '({T}: Add {U} or {B}.)' },
  {
    name: 'Temple of Mystery',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'The Ozolith',
    imageUrl: null,
    fact: 'Whenever a creature you control leaves the battlefield, if it had counters on it, put those counters on The Ozolith.'
  },
  {
    name: 'Temple of Enlightenment',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Jungle Shrine',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {R}, {G}, or {W}.'
  },
  {
    name: 'Cascade Bluffs',
    imageUrl: null,
    fact: '{T}: Add {C}. {U/R}, {T}: Add {U}{U}, {U}{R}, or {R}{R}.'
  },
  {
    name: 'Phyrexian Metamorph',
    imageUrl: null,
    fact: "({U/P} can be paid with either {U} or 2 life.) You may have this creature enter as a copy of any artifact or creature on the battlefield, except it's an artifact in addition to its other types."
  },
  {
    name: 'Reclamation Sage',
    imageUrl: null,
    fact: 'When this creature enters, you may destroy target artifact or enchantment.'
  },
  {
    name: 'Flooded Grove',
    imageUrl: null,
    fact: '{T}: Add {C}. {G/U}, {T}: Add {G}{G}, {G}{U}, or {U}{U}.'
  },
  {
    name: 'Phyrexian Altar',
    imageUrl: null,
    fact: 'Sacrifice a creature: Add one mana of any color.'
  },
  {
    name: 'Azusa, Lost but Seeking',
    imageUrl: null,
    fact: 'You may play two additional lands on each of your turns.'
  },
  {
    name: 'Flusterstorm',
    imageUrl: null,
    fact: 'Counter target instant or sorcery spell unless its controller pays {1}.'
  },
  {
    name: 'Aetherize',
    imageUrl: null,
    fact: "Return all attacking creatures to their owner's hand."
  },
  {
    name: "Urza's Incubator",
    imageUrl: null,
    fact: 'As this artifact enters, choose a creature type.'
  },
  { name: 'Ruby Medallion', imageUrl: null, fact: 'Red spells you cast cost {1} less to cast.' },
  {
    name: 'Guardian Project',
    imageUrl: null,
    fact: "Whenever a nontoken creature you control enters, if it doesn't have the same name as another creature you control or a creature card in your graveyard, draw a card."
  },
  { name: 'Darkwater Catacombs', imageUrl: null, fact: '{1}, {T}: Add {U}{B}.' },
  {
    name: 'Golgari Rot Farm',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Mana Geyser',
    imageUrl: null,
    fact: 'Add {R} for each tapped land your opponents control.'
  },
  { name: 'Harmonize', imageUrl: null, fact: 'Draw three cards.' },
  {
    name: 'Lotus Cobra',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, add one mana of any color.'
  },
  {
    name: 'Scavenger Grounds',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}, {T}, Sacrifice a Desert: Exile all graveyards.'
  },
  {
    name: 'Entomb',
    imageUrl: null,
    fact: 'Search your library for a card, put that card into your graveyard, then shuffle.'
  },
  { name: 'Rakdos Charm', imageUrl: null, fact: "Choose one — • Exile target player's graveyard." },
  {
    name: 'Whispersilk Cloak',
    imageUrl: null,
    fact: "Equipped creature can't be blocked and has shroud."
  },
  {
    name: 'Foreboding Ruins',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Swamp or Mountain card from your hand.'
  },
  {
    name: 'Bastion of Remembrance',
    imageUrl: null,
    fact: 'When this enchantment enters, create a 1/1 white Human Soldier creature token.'
  },
  {
    name: 'Finale of Devastation',
    imageUrl: null,
    fact: 'Search your library and/or graveyard for a creature card with mana value X or less and put it onto the battlefield.'
  },
  {
    name: 'Faerie Mastermind',
    imageUrl: null,
    fact: 'Flash Flying Whenever an opponent draws their second card each turn, you draw a card.'
  },
  {
    name: 'Craterhoof Behemoth',
    imageUrl: null,
    fact: 'Haste When this creature enters, creatures you control gain trample and get +X/+X until end of turn, where X is the number of creatures you control.'
  },
  {
    name: 'Shadowspear',
    imageUrl: null,
    fact: 'Equipped creature gets +1/+1 and has trample and lifelink.'
  },
  { name: 'Putrefy', imageUrl: null, fact: 'Destroy target artifact or creature.' },
  { name: 'Seething Song', imageUrl: null, fact: 'Add {R}{R}{R}{R}{R}.' },
  {
    name: 'Temple of Deceit',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  { name: 'Seat of the Synod', imageUrl: null, fact: '{T}: Add {U}.' },
  {
    name: 'Damn',
    imageUrl: null,
    fact: "Destroy target creature. A creature destroyed this way can't be regenerated."
  },
  {
    name: "Sevinne's Reclamation",
    imageUrl: null,
    fact: 'Return target permanent card with mana value 3 or less from your graveyard to the battlefield.'
  },
  {
    name: 'Blackblade Reforged',
    imageUrl: null,
    fact: 'Equipped creature gets +1/+1 for each land you control.'
  },
  {
    name: 'Arcane Sanctum',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {W}, {U}, or {B}.'
  },
  {
    name: 'Frostboil Snarl',
    imageUrl: null,
    fact: 'As this land enters, you may reveal an Island or Mountain card from your hand.'
  },
  {
    name: 'Dimir Aqueduct',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Utopia Sprawl',
    imageUrl: null,
    fact: 'Enchant Forest As this Aura enters, choose a color.'
  },
  {
    name: 'Fortified Village',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Forest or Plains card from your hand.'
  },
  {
    name: 'Temple of Malady',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  { name: 'Volcanic Island', imageUrl: null, fact: '({T}: Add {U} or {R}.)' },
  {
    name: 'Port Town',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Plains or Island card from your hand.'
  },
  {
    name: 'Kindred Discovery',
    imageUrl: null,
    fact: 'As this enchantment enters, choose a creature type.'
  },
  { name: 'Skycloud Expanse', imageUrl: null, fact: '{1}, {T}: Add {W}{U}.' },
  {
    name: 'Furycalm Snarl',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Mountain or Plains card from your hand.'
  },
  {
    name: 'Fetid Heath',
    imageUrl: null,
    fact: '{T}: Add {C}. {W/B}, {T}: Add {W}{W}, {W}{B}, or {B}{B}.'
  },
  {
    name: 'Anger',
    imageUrl: null,
    fact: 'Haste As long as this card is in your graveyard and you control a Mountain, creatures you control have haste.'
  },
  {
    name: 'Loran of the Third Path',
    imageUrl: null,
    fact: 'Vigilance When Loran enters, destroy up to one target artifact or enchantment.'
  },
  {
    name: "Vanquisher's Banner",
    imageUrl: null,
    fact: 'As this artifact enters, choose a creature type.'
  },
  {
    name: "Jetmir's Garden",
    imageUrl: null,
    fact: '({T}: Add {R}, {G}, or {W}.) This land enters tapped.'
  },
  {
    name: 'Ketria Triome',
    imageUrl: null,
    fact: '({T}: Add {G}, {U}, or {R}.) This land enters tapped.'
  },
  {
    name: 'Baleful Strix',
    imageUrl: null,
    fact: 'Flying, deathtouch When this creature enters, draw a card.'
  },
  {
    name: 'Anointed Procession',
    imageUrl: null,
    fact: 'If an effect would create one or more tokens under your control, it creates twice that many of those tokens instead.'
  },
  {
    name: 'Crumbling Necropolis',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {U}, {B}, or {R}.'
  },
  {
    name: 'Pact of Negation',
    imageUrl: null,
    fact: 'Counter target spell. At the beginning of your next upkeep, pay {3}{U}{U}.'
  },
  {
    name: 'Nomad Outpost',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {R}, {W}, or {B}.'
  },
  { name: 'Go for the Throat', imageUrl: null, fact: 'Destroy target nonartifact creature.' },
  {
    name: 'Rampaging Baloths',
    imageUrl: null,
    fact: 'Trample Landfall — Whenever a land you control enters, create a 4/4 green Beast creature token.'
  },
  { name: 'Tropical Island', imageUrl: null, fact: '({T}: Add {G} or {U}.)' },
  {
    name: 'Authority of the Consuls',
    imageUrl: null,
    fact: 'Creatures your opponents control enter tapped.'
  },
  {
    name: 'Shifting Woodland',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Forest.'
  },
  { name: 'Damnation', imageUrl: null, fact: "Destroy all creatures. They can't be regenerated." },
  { name: 'Tundra', imageUrl: null, fact: '({T}: Add {W} or {U}.)' },
  {
    name: 'Game Trail',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Mountain or Forest card from your hand.'
  },
  {
    name: 'Buried Alive',
    imageUrl: null,
    fact: 'Search your library for up to three creature cards, put them into your graveyard, then shuffle.'
  },
  {
    name: "Dawn's Truce",
    imageUrl: null,
    fact: 'Gift a card (You may promise an opponent a gift as you cast this spell.'
  },
  {
    name: 'Shamanic Revelation',
    imageUrl: null,
    fact: 'Draw a card for each creature you control.'
  },
  {
    name: 'Branching Evolution',
    imageUrl: null,
    fact: 'If one or more +1/+1 counters would be put on a creature you control, twice that many +1/+1 counters are put on that creature instead.'
  },
  { name: "Nature's Claim", imageUrl: null, fact: 'Destroy target artifact or enchantment.' },
  {
    name: 'Aetherflux Reservoir',
    imageUrl: null,
    fact: "Whenever you cast a spell, you gain 1 life for each spell you've cast this turn."
  },
  {
    name: 'Opulent Palace',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {B}, {G}, or {U}.'
  },
  {
    name: 'Eiganjo, Seat of the Empire',
    imageUrl: null,
    fact: '{T}: Add {W}. Channel — {2}{W}, Discard this card: It deals 4 damage to target attacking or blocking creature.'
  },
  {
    name: 'Dauthi Voidwalker',
    imageUrl: null,
    fact: "Shadow (This creature can block or be blocked by only creatures with shadow.) If a card would be put into an opponent's graveyard from anywhere, instead exile it with a void counter on it."
  },
  {
    name: 'Mystic Monastery',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {U}, {R}, or {W}.'
  },
  {
    name: 'Orzhov Basilica',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Twilight Mire',
    imageUrl: null,
    fact: '{T}: Add {C}. {B/G}, {T}: Add {B}{B}, {B}{G}, or {G}{G}.'
  },
  {
    name: 'Toski, Bearer of Secrets',
    imageUrl: null,
    fact: "This spell can't be countered. Indestructible Toski attacks each combat if able."
  },
  { name: 'Consider', imageUrl: null, fact: 'Surveil 1. (Look at the top card of your library.' },
  {
    name: 'Sapphire Medallion',
    imageUrl: null,
    fact: 'Blue spells you cast cost {1} less to cast.'
  },
  {
    name: 'Kutzil, Malamet Exemplar',
    imageUrl: null,
    fact: "Your opponents can't cast spells during your turn."
  },
  {
    name: 'Arena of Glory',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Mountain.'
  },
  { name: 'Scrubland', imageUrl: null, fact: '({T}: Add {W} or {B}.)' },
  { name: 'Badlands', imageUrl: null, fact: '({T}: Add {B} or {R}.)' },
  {
    name: 'Kessig Wolf Run',
    imageUrl: null,
    fact: '{T}: Add {C}. {X}{R}{G}, {T}: Target creature gets +X/+0 and gains trample until end of turn.'
  },
  {
    name: 'Underworld Breach',
    imageUrl: null,
    fact: 'Each nonland card in your graveyard has escape.'
  },
  {
    name: 'Frontier Bivouac',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {G}, {U}, or {R}.'
  },
  {
    name: 'Spire of Industry',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}, Pay 1 life: Add one mana of any color.'
  },
  {
    name: "Spara's Headquarters",
    imageUrl: null,
    fact: '({T}: Add {G}, {W}, or {U}.) This land enters tapped.'
  },
  {
    name: 'Land Tax',
    imageUrl: null,
    fact: 'At the beginning of your upkeep, if an opponent controls more lands than you, you may search your library for up to three basic land cards, reveal them, put them into your hand, then shuffle.'
  },
  {
    name: 'Forgotten Ancient',
    imageUrl: null,
    fact: 'Whenever a player casts a spell, you may put a +1/+1 counter on this creature.'
  },
  {
    name: 'Izzet Boilerworks',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Deathcap Glade',
    imageUrl: null,
    fact: 'This land enters tapped unless you control two or more other lands.'
  },
  {
    name: 'Demolition Field',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}, {T}, Sacrifice this land: Destroy target nonbasic land an opponent controls.'
  },
  {
    name: 'Seaside Citadel',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {G}, {W}, or {U}.'
  },
  {
    name: 'Helm of the Host',
    imageUrl: null,
    fact: "At the beginning of combat on your turn, create a token that's a copy of equipped creature, except the token isn't legendary."
  },
  { name: 'Despark', imageUrl: null, fact: 'Exile target permanent with mana value 4 or greater.' },
  {
    name: 'Goldspan Dragon',
    imageUrl: null,
    fact: 'Flying, haste Whenever this creature attacks or becomes the target of a spell, create a Treasure token.'
  },
  {
    name: 'Guttersnipe',
    imageUrl: null,
    fact: 'Whenever you cast an instant or sorcery spell, this creature deals 2 damage to each opponent.'
  },
  {
    name: 'Zagoth Triome',
    imageUrl: null,
    fact: '({T}: Add {B}, {G}, or {U}.) This land enters tapped.'
  },
  { name: 'Great Furnace', imageUrl: null, fact: '{T}: Add {R}.' },
  {
    name: 'Evolution Sage',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, proliferate.'
  },
  {
    name: 'Kami of Whispered Hopes',
    imageUrl: null,
    fact: 'If one or more +1/+1 counters would be put on a permanent you control, that many plus one +1/+1 counters are put on that permanent instead.'
  },
  {
    name: 'Spark Double',
    imageUrl: null,
    fact: "You may have this creature enter as a copy of a creature or planeswalker you control, except it enters with an additional +1/+1 counter on it if it's a creature, it enters with an additional loyalty counter on it if i..."
  },
  {
    name: 'Lotho, Corrupt Shirriff',
    imageUrl: null,
    fact: 'Whenever a player casts their second spell each turn, you lose 1 life and create a Treasure token.'
  },
  {
    name: 'Parallel Lives',
    imageUrl: null,
    fact: 'If an effect would create one or more tokens under your control, it creates twice that many of those tokens instead.'
  },
  {
    name: 'Bident of Thassa',
    imageUrl: null,
    fact: 'Whenever a creature you control deals combat damage to a player, you may draw a card.'
  },
  {
    name: "Thassa's Oracle",
    imageUrl: null,
    fact: 'When this creature enters, look at the top X cards of your library, where X is your devotion to blue.'
  },
  {
    name: 'Demand Answers',
    imageUrl: null,
    fact: 'As an additional cost to cast this spell, sacrifice an artifact or discard a card.'
  },
  {
    name: 'Mondrak, Glory Dominus',
    imageUrl: null,
    fact: 'If one or more tokens would be created under your control, twice that many of those tokens are created instead.'
  },
  { name: 'Silence', imageUrl: null, fact: "Your opponents can't cast spells this turn." },
  {
    name: 'Gruul Turf',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: "Raffine's Tower",
    imageUrl: null,
    fact: '({T}: Add {W}, {U}, or {B}.) This land enters tapped.'
  },
  {
    name: 'Temple of Malice',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: "Hall of Heliod's Generosity",
    imageUrl: null,
    fact: '{T}: Add {C}. {1}{W}, {T}: Put target enchantment card from your graveyard on top of your library.'
  },
  {
    name: 'Minas Tirith',
    imageUrl: null,
    fact: 'Minas Tirith enters tapped unless you control a legendary creature.'
  },
  {
    name: 'Shineshadow Snarl',
    imageUrl: null,
    fact: 'As this land enters, you may reveal a Plains or Swamp card from your hand.'
  },
  { name: 'Gilded Lotus', imageUrl: null, fact: '{T}: Add three mana of any one color.' },
  { name: 'Tainted Field', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {W} or {B}.' },
  {
    name: 'Mystic Forge',
    imageUrl: null,
    fact: 'You may look at the top card of your library any time.'
  },
  { name: 'Tainted Wood', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {G}.' },
  { name: 'Shadowblood Ridge', imageUrl: null, fact: '{1}, {T}: Add {B}{R}.' },
  {
    name: 'Red Elemental Blast',
    imageUrl: null,
    fact: 'Choose one — • Counter target blue spell.'
  },
  {
    name: 'Warren Soultrader',
    imageUrl: null,
    fact: 'Pay 1 life, Sacrifice another creature: Create a Treasure token.'
  },
  {
    name: 'Welcoming Vampire',
    imageUrl: null,
    fact: 'Flying Whenever one or more other creatures you control with power 2 or less enter, draw a card.'
  },
  {
    name: 'Fanatic of Rhonas',
    imageUrl: null,
    fact: '{T}: Add {G}. Ferocious — {T}: Add {G}{G}{G}{G}.'
  },
  { name: 'Bayou', imageUrl: null, fact: '({T}: Add {B} or {G}.)' },
  {
    name: 'Geier Reach Sanitarium',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}, {T}: Each player draws a card, then discards a card.'
  },
  {
    name: 'Undercity Sewers',
    imageUrl: null,
    fact: '({T}: Add {U} or {B}.) This land enters tapped.'
  },
  {
    name: 'Entish Restoration',
    imageUrl: null,
    fact: 'Sacrifice a land. Search your library for up to two basic land cards, put them onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Mistrise Village',
    imageUrl: null,
    fact: 'This land enters tapped unless you control a Mountain or a Forest.'
  },
  {
    name: 'Etherium Sculptor',
    imageUrl: null,
    fact: 'Artifact spells you cast cost {1} less to cast.'
  },
  { name: 'Ramunap Excavator', imageUrl: null, fact: 'You may play lands from your graveyard.' },
  { name: 'Simian Spirit Guide', imageUrl: null, fact: 'Exile this card from your hand: Add {R}.' },
  { name: 'Sungrass Prairie', imageUrl: null, fact: '{1}, {T}: Add {G}{W}.' },
  {
    name: 'Azorius Chancery',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  { name: 'Taiga', imageUrl: null, fact: '({T}: Add {R} or {G}.)' },
  {
    name: "Urza's Cave",
    imageUrl: null,
    fact: '{T}: Add {C}. {3}, {T}, Sacrifice this land: Search your library for a land card, put it onto the battlefield tapped, then shuffle.'
  },
  { name: 'Read the Bones', imageUrl: null, fact: 'Scry 2, then draw two cards. You lose 2 life.' },
  {
    name: 'Selvala, Heart of the Wilds',
    imageUrl: null,
    fact: "Whenever another creature enters, its controller may draw a card if its power is greater than each other creature's power."
  },
  {
    name: 'Ephemerate',
    imageUrl: null,
    fact: "Exile target creature you control, then return it to the battlefield under its owner's control."
  },
  {
    name: 'Cursed Mirror',
    imageUrl: null,
    fact: '{T}: Add {R}. As this artifact enters, you may have it become a copy of any creature on the battlefield until end of turn, except it has haste.'
  },
  {
    name: 'Expedition Map',
    imageUrl: null,
    fact: '{2}, {T}, Sacrifice this artifact: Search your library for a land card, reveal it, put it into your hand, then shuffle.'
  },
  {
    name: 'Burnished Hart',
    imageUrl: null,
    fact: '{3}, Sacrifice this creature: Search your library for up to two basic land cards, put them onto the battlefield tapped, then shuffle.'
  },
  {
    name: 'Psychosis Crawler',
    imageUrl: null,
    fact: "Psychosis Crawler's power and toughness are each equal to the number of cards in your hand."
  },
  {
    name: 'Walking Ballista',
    imageUrl: null,
    fact: 'This creature enters with X +1/+1 counters on it.'
  },
  { name: "Gaea's Cradle", imageUrl: null, fact: '{T}: Add {G} for each creature you control.' },
  {
    name: 'Mental Misstep',
    imageUrl: null,
    fact: '({U/P} can be paid with either {U} or 2 life.) Counter target spell with mana value 1.'
  },
  {
    name: 'Vault of the Archangel',
    imageUrl: null,
    fact: '{T}: Add {C}. {2}{W}{B}, {T}: Creatures you control gain deathtouch and lifelink until end of turn.'
  },
  { name: 'Plateau', imageUrl: null, fact: '({T}: Add {R} or {W}.)' },
  { name: 'Field of the Dead', imageUrl: null, fact: 'This land enters tapped. {T}: Add {C}.' },
  {
    name: 'Unnatural Growth',
    imageUrl: null,
    fact: 'At the beginning of each combat, double the power and toughness of each creature you control until end of turn.'
  },
  {
    name: 'Goblin Bombardment',
    imageUrl: null,
    fact: 'Sacrifice a creature: This enchantment deals 1 damage to any target.'
  },
  { name: 'Pyroblast', imageUrl: null, fact: "Choose one — • Counter target spell if it's blue." },
  {
    name: 'Diabolic Tutor',
    imageUrl: null,
    fact: 'Search your library for a card, put that card into your hand, then shuffle.'
  },
  {
    name: 'Tatyova, Benthic Druid',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, you gain 1 life and draw a card.'
  },
  {
    name: 'Ohran Frostfang',
    imageUrl: null,
    fact: 'Attacking creatures you control have deathtouch.'
  },
  { name: 'Talisman of Curiosity', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {G} or {U}.' },
  {
    name: 'High Market',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}, Sacrifice a creature: You gain 1 life.'
  },
  {
    name: 'Sram, Senior Edificer',
    imageUrl: null,
    fact: 'Whenever you cast an Aura, Equipment, or Vehicle spell, draw a card.'
  },
  {
    name: 'Cabal Ritual',
    imageUrl: null,
    fact: 'Add {B}{B}{B}. Threshold — Add {B}{B}{B}{B}{B} instead if there are seven or more cards in your graveyard.'
  },
  {
    name: 'Boros Garrison',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  {
    name: 'Sheoldred, the Apocalypse',
    imageUrl: null,
    fact: 'Deathtouch Whenever you draw a card, you gain 2 life.'
  },
  {
    name: 'Indatha Triome',
    imageUrl: null,
    fact: '({T}: Add {W}, {B}, or {G}.) This land enters tapped.'
  },
  {
    name: 'Accursed Marauder',
    imageUrl: null,
    fact: 'When this creature enters, each player sacrifices a nontoken creature of their choice.'
  },
  {
    name: "Xander's Lounge",
    imageUrl: null,
    fact: '({T}: Add {U}, {B}, or {R}.) This land enters tapped.'
  },
  {
    name: 'Snakeskin Veil',
    imageUrl: null,
    fact: 'Put a +1/+1 counter on target creature you control.'
  },
  {
    name: 'Underground Mortuary',
    imageUrl: null,
    fact: '({T}: Add {B} or {G}.) This land enters tapped.'
  },
  { name: 'Savannah', imageUrl: null, fact: '({T}: Add {G} or {W}.)' },
  { name: 'Pearl Medallion', imageUrl: null, fact: 'White spells you cast cost {1} less to cast.' },
  {
    name: 'Ghalta, Primal Hunger',
    imageUrl: null,
    fact: 'This spell costs {X} less to cast, where X is the total power of creatures you control.'
  },
  {
    name: 'Supreme Verdict',
    imageUrl: null,
    fact: "This spell can't be countered. Destroy all creatures."
  },
  {
    name: 'Living Death',
    imageUrl: null,
    fact: 'Each player exiles all creature cards from their graveyard, then sacrifices all creatures they control, then puts all cards they exiled this way onto the battlefield.'
  },
  {
    name: 'Rakdos Carnarium',
    imageUrl: null,
    fact: "This land enters tapped. When this land enters, return a land you control to its owner's hand."
  },
  { name: 'Bedevil', imageUrl: null, fact: 'Destroy target artifact, creature, or planeswalker.' },
  { name: 'Talisman of Resilience', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {G}.' },
  {
    name: 'Temple of Plenty',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Blind Obedience',
    imageUrl: null,
    fact: 'Extort (Whenever you cast a spell, you may pay {W/B}.'
  },
  {
    name: 'Fabricate',
    imageUrl: null,
    fact: 'Search your library for an artifact card, reveal it, put it into your hand, then shuffle.'
  },
  {
    name: 'Maskwood Nexus',
    imageUrl: null,
    fact: 'Creatures you control are every creature type.'
  },
  {
    name: "Chandra's Ignition",
    imageUrl: null,
    fact: 'Target creature you control deals damage equal to its power to each other creature and each opponent.'
  },
  {
    name: 'Felidar Retreat',
    imageUrl: null,
    fact: 'Landfall — Whenever a land you control enters, choose one — • Create a 2/2 white Cat Beast creature token.'
  },
  {
    name: 'Dispatch',
    imageUrl: null,
    fact: 'Tap target creature. Metalcraft — If you control three or more artifacts, exile that creature.'
  },
  {
    name: 'Vito, Thorn of the Dusk Rose',
    imageUrl: null,
    fact: 'Whenever you gain life, target opponent loses that much life.'
  },
  {
    name: 'Temple of Abandon',
    imageUrl: null,
    fact: 'This land enters tapped. When this land enters, scry 1.'
  },
  {
    name: 'Savai Triome',
    imageUrl: null,
    fact: '({T}: Add {R}, {W}, or {B}.) This land enters tapped.'
  },
  {
    name: 'Sanguine Bond',
    imageUrl: null,
    fact: 'Whenever you gain life, target opponent loses that much life.'
  },
  {
    name: 'Raugrin Triome',
    imageUrl: null,
    fact: '({T}: Add {U}, {R}, or {W}.) This land enters tapped.'
  },
  {
    name: "Tamiyo's Safekeeping",
    imageUrl: null,
    fact: 'Target permanent you control gains hexproof and indestructible until end of turn.'
  },
  {
    name: 'Academy Ruins',
    imageUrl: null,
    fact: '{T}: Add {C}. {1}{U}, {T}: Put target artifact card from your graveyard on top of your library.'
  },
  {
    name: 'Oracle of Mul Daya',
    imageUrl: null,
    fact: 'You may play an additional land on each of your turns.'
  },
  {
    name: "Conjurer's Closet",
    imageUrl: null,
    fact: 'At the beginning of your end step, you may exile target creature you control, then return that card to the battlefield under your control.'
  },
  { name: 'Tainted Isle', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {U} or {B}.' },
  {
    name: 'Enduring Vitality',
    imageUrl: null,
    fact: 'Vigilance Creatures you control have "{T}: Add one mana of any color." When Enduring Vitality dies, if it was a creature, return it to the battlefield under its owner\'s control.'
  },
  {
    name: 'Sandsteppe Citadel',
    imageUrl: null,
    fact: 'This land enters tapped. {T}: Add {W}, {B}, or {G}.'
  },
  {
    name: 'Treasure Vault',
    imageUrl: null,
    fact: '{T}: Add {C}. {X}{X}, {T}, Sacrifice this land: Create X Treasure tokens.'
  },
  { name: 'Tainted Peak', imageUrl: null, fact: '{T}: Add {C}. {T}: Add {B} or {R}.' },
  {
    name: 'Necropotence',
    imageUrl: null,
    fact: 'Skip your draw step. Whenever you discard a card, exile that card from your graveyard.'
  },
  {
    name: 'The Meathook Massacre',
    imageUrl: null,
    fact: 'When The Meathook Massacre enters, each creature gets -X/-X until end of turn.'
  },
  {
    name: 'Exquisite Blood',
    imageUrl: null,
    fact: 'Whenever an opponent loses life, you gain that much life.'
  },
  {
    name: 'Imperial Seal',
    imageUrl: null,
    fact: 'Search your library for a card, then shuffle and put that card on top.'
  },
  {
    name: 'Adeline, Resplendent Cathar',
    imageUrl: null,
    fact: "Vigilance Adeline's power is equal to the number of creatures you control."
  },
  {
    name: 'Liquimetal Torque',
    imageUrl: null,
    fact: '{T}: Add {C}. {T}: Target nonland permanent becomes an artifact in addition to its other types until end of turn.'
  },
  {
    name: 'Soul Warden',
    imageUrl: null,
    fact: 'Whenever another creature enters, you gain 1 life.'
  },
  {
    name: 'Wishclaw Talisman',
    imageUrl: null,
    fact: 'This artifact enters with three wish counters on it.'
  },
  {
    name: "Ziatora's Proving Ground",
    imageUrl: null,
    fact: '({T}: Add {B}, {R}, or {G}.) This land enters tapped.'
  },
  {
    name: 'Mother of Runes',
    imageUrl: null,
    fact: '{T}: Target creature you control gains protection from the color of your choice until end of turn.'
  }
]
